import React from "react";
import ViewUserBasicDetailsLayout from "../../layouts/ViewUserBasicDetailsLayout/ViewUserBasicDetailsLayout";
import { Text, ViewFieldData } from "react_reusable_components";
import { Avatar, Divider } from "antd";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";

const viewUserBasicDetailsContainerStyle = {
  userNameTextStyle: {
    fontSize: variables.fontSizeXxlarge,
    lineHeight: variables.lineHeightXxlarge,
    fontWeight: variables.fontWeightBold,
    color: variables.turquoise,
    textTransform:"capitalize"
  },
  avatar: {
    background: variables.avatarBG,
    height: "4.625rem",
    width: "4.625rem",
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    margin: `0 ${variables.marginAuto}`,
    fontSize: variables.fontSizeXxlarge,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightXxlarge,
    borderRadius: "3.125rem",
  },
  dividerStyle: {
    color: variables.darkGrey,
    height: "1.125rem",
  },
};

export default function ViewUserBasicDetailsContainer({ userData }) {
  const intl = useIntl();
  return (
    <ViewUserBasicDetailsLayout
      leftAvatarSection={
        <Avatar
          style={viewUserBasicDetailsContainerStyle.avatar}
          src={userData?.name}
        >
          {userData?.name?.[0]?.toUpperCase()}
          {userData?.name?.split?.(" ")?.[1]?.[0]?.toUpperCase() || ""}
        </Avatar>
      }
      nameSection={
        <Text style={viewUserBasicDetailsContainerStyle.userNameTextStyle}>
          {userData?.name}
        </Text>
      }
      emailSection={
        <ViewFieldData
          label={getLocalizedMessage(intl, "viewUser.label.email")}
          value={userData?.email}
        />
      }
      mobileSection={
        userData?.mobile?.number && (
          <ViewFieldData
            label={getLocalizedMessage(intl, "viewUser.label.mobileNo")}
            value={
              userData?.mobile?.countryCode && userData?.mobile?.number
                ? `${userData?.mobile?.countryCode} ${userData?.mobile?.number}`
                : "-"
            }
          />
        )
      }
      remarkSection={
        userData?.blockedRemark && (
          <ViewFieldData
            label={getLocalizedMessage(intl, "viewUser.label.blockedRemark")}
            value={
              <span style={{ textTransform: "capitalize" }}>
                {userData?.blockedRemark}
              </span>
            }
          />
        )
      }
      dividerSection={
        userData?.mobileNumber?.length > 0 && (
          <Divider
            type="vertical"
            style={viewUserBasicDetailsContainerStyle.dividerStyle}
          />
        )
      }
    />
  );
}
